import slugify from 'slugify';

const getSectionId = (section) => slugify(section.fields.heading, { lower: true, strict: true });

export const formatSections = (sections) => {
  let count = 1;

  return sections.map((section) => {
    const formattedSection = {
      ...section.fields,
      id: section.sys.id,
      tagId: getSectionId(section),
      contentType: section.sys.contentType.sys,
      subsections: section.fields.subSections ? formatSections(section.fields.subSections) : [],
    };

    if (section.fields.isEnumerable) {
      formattedSection.count = count;
      count += 1;
    }

    return formattedSection;
  });
};

export const formatContentPage = (page) => ({
  sys: { ...page.sys },
  fields: {
    introduction: page.fields.introduction,
    shortTitle: page.fields.shortTitle,
    slug: page.fields.slug,
    title: page.fields.title,
    sections: formatSections(page.fields.sections),
  },
});

export const formatMenus = (menus) => {
  const formatMenu = (menu) =>
    menu.map((item) => {
      const { fields } = item;
      const linkfields = fields.link && fields.link.fields;

      return {
        sys: {
          id: item.sys.id,
        },
        fields: {
          heading: fields.heading || null,
          openInNewTab: fields.openInNewTab || null,
          link: {
            fields: linkfields
              ? {
                  hasOverviewPage: linkfields.hasOverviewPage || null,
                  slug: linkfields.slug || null,
                  title: linkfields.title || null,
                  url: linkfields.url || null,
                  versions: linkfields.versions || null,
                }
              : null,
          },
          subMenu: fields.subMenu ? formatMenu(fields.subMenu) : null,
        },
      };
    });

  const mainMenu = formatMenu(menus.mainMenu.fields.content);
  const secondaryMenu = formatMenu(menus.secondaryMenu.fields.content);

  return { mainMenu, secondaryMenu };
};
